import _defineProperty from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { InnerTemplatePart, TemplateInstance, AttrPart } from "./template-parts.js";
import { isNumericString } from "./utils.js";
var pipeModifiers = {
  string: function string(value) {
    return String(value);
  }
};

var PartialTemplate = function PartialTemplate(template) {
  _classCallCheck(this, PartialTemplate);

  this.template = template;
  this.state = void 0;
};

var templates = /* @__PURE__ */new WeakMap();
var templateInstances = /* @__PURE__ */new WeakMap();
var Directives = {
  partial: function partial(part, state) {
    state[part.expression] = new PartialTemplate(part.template);
  },
  if: function _if(part, state) {
    var _a;

    if (evaluateExpression(part.expression, state)) {
      if (templates.get(part) !== part.template) {
        templates.set(part, part.template);
        var tpl = new TemplateInstance(part.template, state, processor);
        part.replace(tpl);
        templateInstances.set(part, tpl);
      } else {
        (_a = templateInstances.get(part)) == null ? void 0 : _a.update(state);
      }
    } else {
      part.replace("");
      templates.delete(part);
      templateInstances.delete(part);
    }
  }
};
var DirectiveNames = Object.keys(Directives);
var processor = {
  processCallback: function processCallback(instance, parts, state) {
    var _a, _b;

    if (!state) return;

    var _iterator = _createForOfIteratorHelper(parts),
        _step;

    try {
      var _loop = function _loop() {
        var _step$value = _slicedToArray(_step.value, 2),
            expression = _step$value[0],
            part = _step$value[1];

        if (part instanceof InnerTemplatePart) {
          if (!part.directive) {
            var directive = DirectiveNames.find(function (n) {
              return part.template.hasAttribute(n);
            });

            if (directive) {
              part.directive = directive;
              part.expression = part.template.getAttribute(directive);
            }
          }

          (_a = Directives[part.directive]) == null ? void 0 : _a.call(Directives, part, state);
          return "continue";
        }

        var value = evaluateExpression(expression, state);

        if (value instanceof PartialTemplate) {
          if (templates.get(part) !== value.template) {
            templates.set(part, value.template);
            value = new TemplateInstance(value.template, value.state, processor);
            part.value = value;
            templateInstances.set(part, value);
          } else {
            (_b = templateInstances.get(part)) == null ? void 0 : _b.update(value.state);
          }

          return "continue";
        }

        if (value) {
          if (part instanceof AttrPart) {
            if (part.attributeName.startsWith("aria-")) {
              value = String(value);
            }
          }

          if (part instanceof AttrPart) {
            if (typeof value === "boolean") {
              part.booleanValue = value;
            } else if (typeof value === "function") {
              part.element[part.attributeName] = value;
            } else {
              part.value = value;
            }
          } else {
            part.value = value;
            templates.delete(part);
            templateInstances.delete(part);
          }
        } else {
          if (part instanceof AttrPart) {
            part.value = void 0;
          } else {
            part.value = void 0;
            templates.delete(part);
            templateInstances.delete(part);
          }
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};
var operators = {
  "!": function _(a) {
    return !a;
  },
  "!!": function _(a) {
    return !!a;
  },
  "==": function _(a, b) {
    return a == b;
  },
  "!=": function _(a, b) {
    return a != b;
  },
  ">": function _(a, b) {
    return a > b;
  },
  ">=": function _(a, b) {
    return a >= b;
  },
  "<": function _(a, b) {
    return a < b;
  },
  "<=": function _(a, b) {
    return a <= b;
  },
  "??": function _(a, b) {
    return a != null ? a : b;
  },
  "|": function _(a, b) {
    var _a;

    return (_a = pipeModifiers[b]) == null ? void 0 : _a.call(pipeModifiers, a);
  }
};

function tokenizeExpression(expr) {
  return tokenize(expr, {
    boolean: /true|false/,
    number: /-?\d+\.?\d*/,
    string: /(["'])((?:\\.|[^\\])*?)\1/,
    operator: /[!=><][=!]?|\?\?|\|/,
    ws: /\s+/,
    param: /[$a-z_][$\w]*/i
  }).filter(function (_ref) {
    var type = _ref.type;
    return type !== "ws";
  });
}

function evaluateExpression(expr) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a, _b, _c, _d, _e, _f, _g;

  var tokens = tokenizeExpression(expr);

  if (tokens.length === 0 || tokens.some(function (_ref2) {
    var type = _ref2.type;
    return !type;
  })) {
    return invalidExpression(expr);
  }

  if (((_a = tokens[0]) == null ? void 0 : _a.token) === ">") {
    var partial = state[(_b = tokens[1]) == null ? void 0 : _b.token];

    if (!partial) {
      return invalidExpression(expr);
    }

    var partialState = _objectSpread({}, state);

    partial.state = partialState;
    var args = tokens.slice(2);

    for (var i = 0; i < args.length; i += 3) {
      var name = (_c = args[i]) == null ? void 0 : _c.token;
      var operator = (_d = args[i + 1]) == null ? void 0 : _d.token;
      var value = (_e = args[i + 2]) == null ? void 0 : _e.token;

      if (name && operator === "=") {
        partialState[name] = getParamValue(value, state);
      }
    }

    return partial;
  }

  if (tokens.length === 1) {
    if (!isValidParam(tokens[0])) {
      return invalidExpression(expr);
    }

    return getParamValue(tokens[0].token, state);
  }

  if (tokens.length === 2) {
    var _operator = (_f = tokens[0]) == null ? void 0 : _f.token;

    var run = operators[_operator];

    if (!run || !isValidParam(tokens[1])) {
      return invalidExpression(expr);
    }

    var a = getParamValue(tokens[1].token, state);
    return run(a);
  }

  if (tokens.length === 3) {
    var _operator2 = (_g = tokens[1]) == null ? void 0 : _g.token;

    var _run = operators[_operator2];

    if (!_run || !isValidParam(tokens[0]) || !isValidParam(tokens[2])) {
      return invalidExpression(expr);
    }

    var _a2 = getParamValue(tokens[0].token, state);

    if (_operator2 === "|") {
      return _run(_a2, tokens[2].token);
    }

    var b = getParamValue(tokens[2].token, state);
    return _run(_a2, b);
  }
}

function invalidExpression(expr) {
  console.warn("Warning: invalid expression `".concat(expr, "`"));
  return false;
}

function isValidParam(_ref3) {
  var type = _ref3.type;
  return ["number", "boolean", "string", "param"].includes(type);
}

function getParamValue(raw, state) {
  var firstChar = raw[0];
  var lastChar = raw.slice(-1);

  if (raw === "true" || raw === "false") {
    return raw === "true";
  }

  if (firstChar === lastChar && ["'", "\""].includes(firstChar)) {
    return raw.slice(1, -1);
  }

  if (isNumericString(raw)) {
    return parseFloat(raw);
  }

  return state[raw];
}

function tokenize(str, parsers) {
  var len,
      match,
      token,
      tokens = [];

  while (str) {
    token = null;
    len = str.length;

    for (var key in parsers) {
      match = parsers[key].exec(str);

      if (match && match.index < len) {
        token = {
          token: match[0],
          type: key,
          matches: match.slice(1)
        };
        len = match.index;
      }
    }

    if (len) {
      tokens.push({
        token: str.substr(0, len),
        type: void 0
      });
    }

    if (token) {
      tokens.push(token);
    }

    str = str.substr(len + (token ? token.token.length : 0));
  }

  return tokens;
}

export { evaluateExpression, getParamValue, processor, tokenizeExpression };